<div
  class="media-selector-general"
  (drop)="onDropFile($event)"
  (dragover)="onDragOverFile($event)"
>
  <div class="media-selector-general__step-text bold">
    {{ 'TRANS__IMAGE_SELECTOR__STEP_1_HEADLINE' | translate }}
  </div>

  <input
    #fileInput
    type="file"
    (change)="onFileSelect($event)"
    [attr.multiple]="multipleFiles ? 'multiple' : undefined"
    [attr.accept]="fileAccept"
  >

  <div class="media-selector-general__image-drop-zone">
    <button
      type="button"
      class="media-selector-general__choose-files"
      (click)="uploadFile(fileInput)"
    >
      <mat-icon aria-hidden="true">upload</mat-icon>
      <span>{{ 'TRANS__IMAGE_SELECTOR__CHOOSE_FILES' | translate }}</span>
      <span class="media-selector-general__drop-hint">{{ 'TRANS__IMAGE_SELECTOR__DROP_FILES' | translate }}</span>
    </button>
  </div>

  @if (computer && fromCamera) {
    <div class="media-selector-general__buttons">
      <button
        mat-stroked-button
        color="primary"
        type="button"
        (click)="openCamera()"
        [class.active]="cameraOpen"
        [attr.aria-pressed]="cameraOpen"
      >
        <mat-icon aria-hidden="true">photo_camera</mat-icon>

        <span>
          {{ uploadInfo.text_from_camera | translate }}
        </span>
      </button>
    </div>
  }

  @if (selectFromParent && parentMedia.length) {
    <div class="media-selector-general__buttons">
      <button
        mat-stroked-button
        color="primary"
        type="button"
        (click)="selectFiles()"
        [ngClass]="{'active':selectImg}"
      >
        <i class="icon-select1"></i>

        <span>
          {{ uploadInfo.text_select_from_parent | translate }}
        </span>
      </button>
    </div>
  }

  @if (cameraOpen) {
    <div class="media-selector-general__cameraOpen">
      <h5 class="bold">
        {{ 'TRANS__IMAGE_SELECTOR__NEW_IMAGE_CAMERA' | translate }}
      </h5>

      <app-media-upload-camera
        (uploadCameraImages)="uploadFiles($event)"
        [fileAccept]="fileAccept"
      ></app-media-upload-camera>
    </div>
  }

  @if (selectImg && parentMedia.length) {
    <div class="full-width">
      <app-media-selector-selected-files
        class="full-width"
        [selectedFiles]="files"
        [files]="parentMedia"
        [showSelected]="true"
        [text]="'TRANS__IMAGE_SELECTOR__CHOOSE_OBJECT_IMAGE'"
        [imageIdField]="'image_id'"
        (itemSelected)="onSelectedItem($event)"
      ></app-media-selector-selected-files>
    </div>
  }

  @if (files.length) {
    <app-media-selector-selected-files
      class="media-selector-general__selected-files"
      [files]="files"
      (fileDeleted)="handleFileDeleted($event)"
      [showSelected]="false"
      [text]="null"
      [_snackBar]="snackBarSignal"
      [imageIdField]="'image_id'"
    ></app-media-selector-selected-files>
  }
</div>
